import { ReactElement } from 'react';
import { View } from 'react-native';
import { TIconProps } from '@/common/components/Icons/Icon';
import { tv } from '@/common/theme/tv.config';
import { bgVariants } from '@/common/theme/variants';
import { TColors } from '@coverflex-tech/hypernova-design-tokens';

const validRatios = [16, 24, 32, 40, 48, 56, 64] as const;

export interface IIconBadgeProps {
  ratio: (typeof validRatios)[number];
  icon: ReactElement<TIconProps>;
  backgroundColor?: keyof TColors['light']['semantic']['surface'];
  className?: string;
}

export const IconBadge = ({
  ratio = 16,
  icon,
  backgroundColor,
  className,
}: IIconBadgeProps) => {
  return (
    <View className={styles.root({ ratio, backgroundColor, className })}>
      {icon}
    </View>
  );
};

const styles = {
  root: tv({
    base: 'items-center justify-center overflow-hidden',
    variants: {
      ratio: {
        16: 'h-[1.6rem] w-[1.6rem] rounded-sm',
        24: 'h-[2.4rem] w-[2.4rem] rounded-md',
        32: 'h-[3.2rem] w-[3.2rem] rounded-md',
        40: 'h-[4.0rem] w-[4.0rem] rounded-lg',
        48: 'h-[4.8rem] w-[4.8rem] rounded-lg',
        56: 'h-[5.6rem] w-[5.6rem] rounded-xl',
        64: 'h-[6.4rem] w-[6.4rem] rounded-xl',
      },
      backgroundColor: bgVariants,
    },
    defaultVariants: {
      ratio: 16,
      backgroundColor: 'neutral30',
    },
  }),
};
